const ones = [
  "", "One", "Two", "Three", "Four", "Five",
  "Six", "Seven", "Eight", "Nine", "Ten", "Eleven",
  "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
  "Seventeen", "Eighteen", "Nineteen"
];

const tens = [
  "", "", "Twenty", "Thirty", "Forty", "Fifty",
  "Sixty", "Seventy", "Eighty", "Ninety"
];

const convertNumberToWords = (num) => {
  if (num === 0) return "Zero";

  if (num < 0) return "Minus " + convertNumberToWords(Math.abs(num));

  let result = "";

  const helper = (n) => {
    let str = "";
    if (n < 20) {
      str = ones[n];
    } else if (n < 100) {
      str = tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
    } else if (n < 1000) {
      str = ones[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + helper(n % 100) : "");
    }
    return str;
  };

  if (num >= 1_00_00_000) {
    result += convertNumberToWords(Math.floor(num / 1_00_00_000)) + " Crore ";
    num %= 1_00_00_000;
  }

  if (num >= 1_00_000) {
    result += convertNumberToWords(Math.floor(num / 1_00_000)) + " Lakh ";
    num %= 1_00_000;
  }

  if (num >= 1000) {
    result += convertNumberToWords(Math.floor(num / 1000)) + " Thousand ";
    num %= 1000;
  }

  if (num > 0) {
    result += helper(num);
  }

  return result.trim();
};

export const convertAmountToWords = (amount) => {
  const [rupees, paise] = amount.toString().split(".");
  let result = convertNumberToWords(parseInt(rupees)) + " Rupees";
  if (paise) {
    const p = parseInt(paise.substring(0, 2)); // Only 2 decimal places
    if (p > 0) {
      result += " and " + convertNumberToWords(p) + " Paise";
    }
  }
  return result + " Only";
};
